import React from "react";
import loadingImg from "./../../Assets/Image/LoadingSpin.gif";
import clock from "./../../Assets/Icons/clock.png";
import warning from "./../../Assets/Icons/warning-sign.png";
import down from "./../../Assets/Icons/down.png";
import { getFoodStatus } from "./foodItemLogic";
import "./FoodItem.css";

export default function FoodActionButton({
  loading,
  food,
  mode,
  totalPrice,
  handleSave,
  setShowUnavailableReasonModal,
  setShowOutOfHourModal,
}) {
  const foodStatus = getFoodStatus(food?.isActive, food?.status);

  // 1. Show loading button
  if (loading) {
    return (
      <button
        className='btn-addtocart'
        type='button'
        style={{ pointerEvents: "none", cursor: "no-drop" }}
      >
        <img
          src={loadingImg}
          className='img-fluid'
          style={{ height: "1rem" }}
          alt='loading'
        />
      </button>
    );
  }

  // 2. Show "Unavailable" button
  if (foodStatus === "Unavailable") {
    return (
      <button
        className='btn-addtocart d-flex justify-content-center align-items-center add-btn-disabled'
        type='button'
        onClick={() => setShowUnavailableReasonModal(true)}
      >
        <div className='icon-container icon-no-background'>
          <img src={warning} alt='warning' />
        </div>
        <div className='mx-2'>Unavailable</div>
        <div className='icon-container icon-no-background'>
          <img src={down} alt='down' />
        </div>
      </button>
    );
  }

  // 3. Show "Out of hour" button
  if (foodStatus === "Out of hour") {
    return (
      <button
        className='btn-addtocart d-flex justify-content-center align-items-center add-btn-disabled'
        type='button'
        onClick={() => setShowOutOfHourModal(true)}
      >
        <div className='icon-container'>
          <img src={clock} alt='clock' />
        </div>
        <div className='mx-2'>Out of hour</div>
        <div className='icon-container icon-no-background'>
          <img src={down} alt='down' />
        </div>
      </button>
    );
  }

  // 4. Default: Show "Add to Cart" button
  return (
    <button className='btn-addtocart' type='button' onClick={handleSave}>
      {mode === "edit" ? "Update Item For" : "Add to Cart For"} $
      {totalPrice.toFixed(2)}
    </button>
  );
}
